import _get from "@babel/runtime/helpers/get";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Writable } from 'stream';
import MicrophoneStream from 'microphone-stream';
import getUserMedia from 'getusermedia';
import DropStream from 'drop-stream';

var VoiceHandler = /*#__PURE__*/function (_Writable) {
  _inherits(VoiceHandler, _Writable);

  var _super = _createSuper(VoiceHandler);

  function VoiceHandler(index, client, settings) {
    var _this;

    _classCallCheck(this, VoiceHandler);

    _this = _super.call(this, {
      objectMode: true
    });
    _this._index = index; //zcx add, to get current channel id

    _this._client = client;
    _this._settings = settings;
    _this._outbound = null;
    return _this;
  }

  _createClass(VoiceHandler, [{
    key: "nowTalk",
    value: function nowTalk() {
      this._pushed = true;
    }
  }, {
    key: "pttDown",
    value: function pttDown() {
      this._client.applyMic(true);
    }
  }, {
    key: "pttUp",
    value: function pttUp() {
      //发现后1-2个字被吞，所以延迟一会放麦
      var tmpClient = this._client;
      var tmpThis = this;

      function doPttUp() {
        //先UserTalking(false)
        tmpClient.reportTalking(false);
        tmpClient.applyMic(false);

        tmpThis._stopOutbound();

        tmpThis._pushed = false;
      }

      setTimeout(doPttUp, 300);
    }
  }, {
    key: "_getOrCreateOutbound",
    value: function _getOrCreateOutbound() {
      if (!this._outbound) {
        if (!this._client) {
          this._outbound = DropStream.obj();
          this.emit('started_talking');
          return this._outbound;
        }

        this._outbound = this._client.createVoiceStream(960); //发现localhost访问正常960，ip地址访问就是160.所以写死960

        this.emit('started_talking');
      }

      return this._outbound;
    }
  }, {
    key: "_stopOutbound",
    value: function _stopOutbound() {
      if (this._outbound) {
        this.emit('stopped_talking');

        this._outbound.end();

        this._outbound = null;
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      this._stopOutbound();

      callback();
    }
  }]);

  return VoiceHandler;
}(Writable);

export var PushToTalkVoiceHandler = /*#__PURE__*/function (_VoiceHandler) {
  _inherits(PushToTalkVoiceHandler, _VoiceHandler);

  var _super2 = _createSuper(PushToTalkVoiceHandler);

  function PushToTalkVoiceHandler(index, client, settings) {
    var _this2;

    _classCallCheck(this, PushToTalkVoiceHandler);

    _this2 = _super2.call(this, index, client, settings);
    _this2._pushed = false;
    return _this2;
  }

  _createClass(PushToTalkVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      //登录后，一直循环运行到这里，但是否发生，由_pushed控制
      if (this._pushed) {
        this._getOrCreateOutbound().write(data, callback);
      } else {
        callback();
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      _get(_getPrototypeOf(PushToTalkVoiceHandler.prototype), "_final", this).call(this, function (e) {
        callback(e);
      });
    }
  }]);

  return PushToTalkVoiceHandler;
}(VoiceHandler);
export function initVoice(onData, onUserMediaError) {
  getUserMedia({
    audio: true
  }, function (err, userMedia) {
    if (err) {
      onUserMediaError(err);
    } else {
      var micStream = new MicrophoneStream(userMedia, {
        objectMode: true,
        bufferSize: 1024
      });
      micStream.on('data', function (data) {
        //登录后，无论是否开始讲话，这里一直运行
        onData(Buffer.from(data.getChannelData(0).buffer));
      });
    }
  });
}